import { useState } from "react";
import { useRouter } from "next/router";

import { Button, ErrorUI, SVGSprite } from "@/components/Atoms";
import WaitListModal from "../WaitListModal";

import { getURLParams } from "@/utils";
import { useAppSelector } from "@/hooks";

import styles from "./SingleClassPurchaseFlow.module.scss";

const SingleClassPurchaseFlow: React.FC<any> = () => {
  const router = useRouter();

  const params = getURLParams();
  const classId = params?.get("class_id") || "";

  const { packages, classData, waitListSuccess } = useAppSelector(
    (state) => state.shyftPass
  );

  const [openWaitListModal, setOpenWaitListModal] = useState(false);

  const arrowRight = (
    <SVGSprite
      className="icon"
      icon="icon-arrow-right-book-slot"
      height="24px"
      width="24px"
      style={{ marginLeft: "4px" }}
    />
  );

  const arrowIcon = (
    <SVGSprite
      className="icon"
      icon="icon-arrow-right-book-slot"
      height="24px"
      width="24px"
    />
  );

  const successIcon = (
    <SVGSprite
      className="icon"
      icon="icon-arrow-right-success"
      height="24px"
      width="24px"
      fill="#fff"
    />
  );

  let button;
  if (classData?.is_event_ended) {
    button = (
      <Button variant={"primary1"} className="all-slots-booked" disabled>
        {classData?.event_ended_message ||
          "Can't book now. This event has ended!"}
      </Button>
    );
  } else if (classData?.has_all_slots_booked) {
    if (classData?.is_waitlist_enabled) {
      button = (
        <div className="wait-list-wrapper">
          <ErrorUI
            error={
              classData?.all_slots_booked_message || "All slots are booked!"
            }
            isNotAbsolute
            iconDimension="18px"
            fontSize="14px"
            lineHeight="24px"
          />
          {classData?.is_waitlist_joined || waitListSuccess ? (
            <Button
              variant={"primary1"}
              TextColor="#32D583"
              className={styles.single}
            >
              Added to waitlist
              {successIcon}
            </Button>
          ) : (
            <Button
              variant={"primary1"}
              className={styles.single}
              onClick={() =>
                setOpenWaitListModal({
                  title: classData?.session_title,
                  centerTiming: classId,
                })
              }
            >
              Join the waitlist
              {arrowIcon}
            </Button>
          )}
        </div>
      );
    } else {
      button = (
        <Button variant={"primary1"} className="all-slots-booked" disabled>
          All slots are booked
        </Button>
      );
    }
  } else {
    button = (
      <Button
        className={styles.single}
        variant="primary1"
        onClick={() => {
          router.push({
            pathname: "/shyftpass/book-class/register/",
            query: router.query,
          });
        }}
        id="single-class-purchase-button"
      >
        Book a slot for this workout for {packages?.[0]?.price}
        {arrowRight}
      </Button>
    );
  }

  return (
    <div className={styles.actionButtons}>
      {button}
      <Button
        className={styles.monthly}
        variant="primary1"
        onClick={() => {
          window.location.href = "/shyftpass#buynow";
        }}
        id="shyftpass-purchase-button"
      >
        Buy Shyft Pass for 999 for a month
        {arrowRight}
      </Button>
      {openWaitListModal && (
        <WaitListModal
          openWaitListModal={openWaitListModal}
          setOpenWaitListModal={setOpenWaitListModal}
        />
      )}
    </div>
  );
};

export default SingleClassPurchaseFlow;
